import { ComponentProps } from "react";

export const NavbarContentRight = ({ children }: ComponentProps<"div">) => {
  return (
    <div data-testid="navbar-content-right" className="z-10 flex flex-row items-center justify-end mr-4 md:gap-2">
      {children}
    </div>
  );
};
